import {ENDPOINT_EHP} from 'common/endpoints';
import {CALL_API} from 'redux-api-middleware';
import {
  API_EHP_GET_REQUEST,
  API_EHP_GET_SUCCESS,
  API_EHP_GET_FAILURE,
} from 'common/types';
import {commonJwtHeader} from 'common/utils';

export default {
  getConditions: (token, projectIds) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_EHP}conditions`,
        headers: commonJwtHeader(),
        method: 'POST',
        body:JSON.stringify(
          {"projectIds": projectIds}
        ),
        types: [API_EHP_GET_REQUEST, API_EHP_GET_SUCCESS, API_EHP_GET_FAILURE],
      },
    };
  }
};
